import React, { ReactElement } from 'react';
import {
  Button, Td, Th, Tr,
} from 'idsk-react-components';
import PrispevokVestnika from '../../../model/PrispevokVestnika';
import PrispevokVestnikaStepEnum from '../../../model/PrispevokVestnikaStepEnum';
import mapDate from '../../../function/mapDate';

interface Props {
  prispevokVestnika: PrispevokVestnika;
  onChange: (nextStep: PrispevokVestnikaStepEnum) => Promise<void>;
}

const FilledTableDates2 = ({
  onChange,
  prispevokVestnika,
}: Props): ReactElement => (
  <>
    <Tr>
      <Th>Dátum zverejnenia</Th>
      <Td>{mapDate(prispevokVestnika.datumZverejnenia)}</Td>
      <Td>
        <Button
          size="small"
          buttonStyle="link"
          onClick={() => {
            onChange(PrispevokVestnikaStepEnum.DATES_2);
          }}
        >
          Zmeniť
        </Button>
      </Td>
    </Tr>
    <Tr>
      <Th>Dátum účinnosti
        <span className="idsk-hint">(nepovinný údaj)</span>
      </Th>
      <Td>{mapDate(prispevokVestnika.datumUcinnosti)}</Td>
      <Td>
        <Button
          size="small"
          buttonStyle="link"
          onClick={() => {
            onChange(PrispevokVestnikaStepEnum.DATES_2);
          }}
        >
          Zmeniť
        </Button>
      </Td>
    </Tr>
  </>
);
export default FilledTableDates2;
